module.exports = __webpack_public_path__ + "static/img/news-demo5.1531584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/news-demo5.png
// module id = EsP/
// module chunks = 150